import { buildSlice, CommonState } from '~libs/reduxUtils';
import { BulkAssignee } from '~weekly-planner/lib/common';

import { getAll, typePrefix } from '~weekly-planner/actions/appointments/bulkAssignees';

const initialState: CommonState<BulkAssignee> = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  rows: [],
};

const slice = buildSlice<CommonState<BulkAssignee>, BulkAssignee>(typePrefix, initialState, {
  commonConfig: { getAll },
});

export const { clear, updateParams } = slice.actions;
export default slice.reducer;
